import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
const DownLoad = () => import("../views/home/downLoad.vue");
const Home = () => import("../views/home/Home.vue");
const Guide = () => import("../views/home/guide.vue");
const Index = () => import("../views/home/index.vue");
const personalCenterIndex = () => import("../views/personalCenter/index.vue");
const competitionEnroll = () => import("../views/competitionEnroll/index.vue");
//思政教育工作室
const szStudio = () => import("../views/szStudio/index.vue");
const alApply = () => import("../views/alApply/index.vue");
const xalApply = () => import("../views/xalApply/index.vue");
const szStudioDataUpload = () => import("../views/szStudio/dataUpload.vue");
const szStudioLetterCommitment = () =>
  import("../views/szStudio/letterCommitment.vue");
const xalLetterCommitment = () =>
  import("../views/xalApply/letterCommitment.vue");
//特色文化育人
const educationalBrand = () => import("../views/educationalBrand/index.vue");
const educationalBrandDataUpload = () =>
  import("../views/educationalBrand/dataUpload.vue");
const educationalBrandLetterCommitment = () =>
  import("../views/educationalBrand/letterCommitment.vue");
//思政微课
const szMicroClass = () => import("../views/szMicroClass/index.vue");
const szMicroClassDataUpload = () =>
  import("../views/szMicroClass/dataUpload.vue");
const szMicroClassLetterCommitment = () =>
  import("../views/szMicroClass/letterCommitment.vue");
Vue.use(VueRouter);
const systemSettings = () => import("../views/systemSettings/index.vue");
const systemSettingsResult = () => import("../views/systemSettings/result.vue");
const systemSettingsReviewSetUp = () =>
  import("../views/systemSettings/reviewSetUp.vue");
const systemSettingsSetUp = () => import("../views/systemSettings/setUp.vue");
const systemSettingsUserManagement = () =>
  import("../views/systemSettings/userManagement.vue");
const Notice = () => import("../views/notice/index.vue");
const rateScore = () =>
  import("../components/common/rateScore.vue");
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    meta: {
      title: "首页",
    },
    component: () => import("../views/home/indexhome.vue"),
    children: [
      {
        path: "/",
        redirect: "/home/index1",
      },
      {
        path: "/home/index1",
        name: "Index",
        meta: {
          title: "首页",
        },
        component: () => import("../views/home/indexnew.vue"),
      },
      {
        path: "/notice/list",
        name: "noticeList",
        component: () => import("../views/notice/list.vue"),
      },
      {
          path: "/notice/detail",
          name: "noticeDetail",
          component: () => import("../views/notice/detail.vue"),
      },
      {
          path: "/workshow",
          name: "workshow",
          component: () => import("../views/home/workshow.vue"),
      },
      {
        path: "/register",
        name: "register",
        component: () => import("../views/home/register.vue"),
      },
    ]
  },
  // {
  //   path: "/home",
  //   name: "Home",
  //   meta: {
  //     title: "首页",
  //   },
  //   component: Home,
  //   children: [
  //     {
  //       path: "/",
  //       redirect: "/home/index1",
  //     },
  //     {
  //       path: "/home/index1",
  //       name: "Index",
  //       meta: {
  //         title: "首页",
  //       },
  //       component: () => import("../views/home/index1.vue"),
  //     },
  //     {
  //       path: "/home/login/:type",
  //       name: "Index",
  //       meta: {
  //         title: "登录",
  //       },
  //       component: () => import("../views/home/login.vue"),
  //     },
  //   ],
  // },
  // 通知公告
  {
    path: "/notice",
    name: "notice",
    component: () => import("../views/notice/layout.vue"),
    redirect: "/notice/list",
    children: [
      {
        path: "/notice/list",
        name: "noticeList",
        component: () => import("../views/notice/list.vue"),
      },
      {
        path: "/notice/detail",
        name: "noticeDetail",
        component: () => import("../views/notice/detail.vue"),
      },
    ]
  },
  // 注册
 
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: personalCenterIndex,
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "/personalCenter",
        redirect: "/personalCenter/szStudio",
      },
      {
        path: "/personalCenter/downLoad",
        name: "DownLoad",
        meta: {
          title: "下载文件",
        },
        component: DownLoad,
      },
      {
        path: "/personalCenter/guide",
        name: "Guide",
        meta: {
          title: "申报指南",
        },
        component: Guide,
      },
      {
        path: "/personalCenter/competitionEnroll",
        name: "competitionEnroll",
        meta: {
          title: "大赛报名",
        },
        component: competitionEnroll,
      },
      {
        path: "/personalCenter/szStudio/dataUpload",
        name: "szStudioDataUpload",
        component: () => import("../views/szStudio/dataUpload.vue"),
        meta: {
          title: "教学能力大赛",
        },
      },
      {
        path: "/personalCenter/szStudio/letterCommitment",
        name: "szStudioLetterCommitment",
        component: szStudioLetterCommitment,
        meta: {
          title: "承诺书",
        },
      },
      {
        path: "/personalCenter/szMicroClass/dataUpload",
        name: "szMicroClassDataUpload",
        component: szMicroClassDataUpload,
        meta: {
          title: "思政微课",
        },
      },
      {
        path: "/personalCenter/szMicroClass/letterCommitment",
        name: "szMicroClassLetterCommitment",
        component: szMicroClassLetterCommitment,
        meta: {
          title: "承诺书",
        },
      },
      {
        path: "/personalCenter/educationalBrand/dataUpload",
        name: "educationalBrandDataUpload",
        component: educationalBrandDataUpload,
        meta: {
          title: "名班主任工作室建设组",
        },
      },
      {
        path: "/personalCenter/educationalBrand/letterCommitment",
        name: "educationalBrandLetterCommitment",
        component: educationalBrandLetterCommitment,
        meta: {
          title: "承诺书",
        },
      },
      {
        path: "/personalCenter/szStudio",
        name: "szStudio",
        component: szStudio,
        meta: {
          title: "教学能力大赛",
        },
      },
      {
        path: "/personalCenter/alApply",
        name: "alApply",
        component: alApply,
        meta: {
          title: "网络育人创新联盟",
        },
      },
      {
        path: "/personalCenter/alApply/dataUpload",
        name: "alApplyDataUpload",
        component: () => import("../views/alApply/dataUpload.vue"),
        meta: {
          title: "网络育人创新联盟",
        },
      },
      {
        path: "/personalCenter/xalApply",
        name: "xal",
        component: xalApply,
        meta: {
          title: "典型小案例申报",
        },
      },
      {
        path: "/personalCenter/xal/letterCommitment",
        name: "xalLetterCommitment",
        component: xalLetterCommitment,
        meta: {
          title: "承诺书",
        },
      },
      {
        path: "/personalCenter/xalApply/dataUpload",
        name: "xalDataUpload",
        component: () => import("../views/xalApply/dataUpload.vue"),
        meta: {
          title: "典型小案例申报",
        },
      },
      {
        path: "/personalCenter/notice",
        name: "Notice",
        component: Notice,
        meta: {
          title: "通知公告",
        },
      },
      {
        path: "/personalCenter/systemSettings",
        name: "systemSettings",
        component: systemSettings,
        meta: {
          title: "系统设置",
        },
        children: [
          {
            path: "/personalCenter/systemSettings/result",
            name: "systemSettingsResult",
            component: systemSettingsResult,
            meta: {
              title: "评审结果",
            },
          },
          {
            path: "/personalCenter/systemSettings/reviewSetUp",
            name: "systemSettingsReviewSetUp",
            component: systemSettingsReviewSetUp,
            meta: {
              title: "评审设置",
            },
          },
          {
            path: "/personalCenter/systemSettings/setUp",
            name: "systemSettingsSetUp",
            component: systemSettingsSetUp,
            meta: {
              title: "申报设置",
            },
          },
          {
            path: "/personalCenter/systemSettings/userManagement",
            name: "systemSettingsUserManagement",
            component: systemSettingsUserManagement,
            meta: {
              title: "用户管理",
            },
          },
        ],
      },
      {
        path: "/personalCenter/szMicroClass",
        name: "szMicroClass",
        component: szMicroClass,
        meta: {
          title: "思政微课",
        },
      },
      {
        path: "/personalCenter/educationalBrand",
        name: "educationalBrand",
        component: educationalBrand,
        meta: {
          title: "名班主任工作室建设组",
        },
      },
      {
        path: "/personalCenter/lottery",
        name: "lottery",
        component: () => import("../views/lottery/index.vue"),
        meta: {
          title: "抽签",
        },
      },
      {
        path: "/personalCenter/lotteryResult",
        name: "lotteryResult",
        component: () => import("../views/lotteryResult/index.vue"),
        meta: {
          title: "抽签结果公示",
        },
      },
      {
        path: "/personalCenter/rateScore",
        name: "rateScore",
        component: rateScore,
        meta: {
          title: "评审表",
        },
      },
      {
        path: "/personalCenter/registrationForm",
        name: "registrationForm",
        component: () => import("../views/registrationForm/index.vue"),
        meta: {
          title: "报名表上传",
        },
      },
      {
        path: "/personalCenter/registrationManage",
        name: "registrationManage",
        component: () => import("../views/registrationManage/index.vue"),
        meta: {
          title: "报名表管理",
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});
router.beforeEach((to, from, next) => {
  let token = store.state.token;
  console.log(to.path)
  console.log(to.name)
  // 防止当前已经在目标路由时，再次跳转
  // if (to.path === '/home/index1') {
  //   return next(); // 如果已经在首页，直接跳过
  // }

  // 如果用户已经登录，继续路由跳转
  if (token !== null || to.name === 'Index' || to.name === 'Indexs' || to.name === 'noticeDetail' || to.name === 'noticeList'|| to.name === 'workshow' || to.name === 'register') {
    next();
  } else {
    // 如果没有 token，跳转到首页
    next("/home/index1");
  }
});

export default router;
